import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";

const AfiS1 = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>
                    {t('Запустите свой проект с')}
                <br/>
                <span>OMT Launchpad</span>
                </div>
                <div className={`${Styles.contentWrapNote}`}>{t('Мы работаем с ограниченным числом проектов, которые готовы развиваться после запуска и строить долгосрочную ценность.')}</div>
                <div className={`${Styles.applyBtn}`} onClick={() => navigate('/apply-form')}>{t('Подать заявку')}</div>
            </div>
        </section>
    );
};

export default AfiS1;




